
import { Component } from 'react'
import Post from '../../src/components/post'
import ComponentTree from '../../src/components/component-tree'
import components from '../../src/components/md-components'

export default (props) => {
  const data = {
  "layout": "post",
  "title": "phl sunset",
  "created": "2016-09-21",
  "comments": "true",
  "categories": "[\"photo\", \"philadelphia\", \"golden hour\"]",
  "path": "pages/posts/undefined.js",
  "permalink": "posts/undefined",
  "tags": [
    "photo",
    "philadelphia",
    "golden hour"
  ],
  "draft": false
}
  const body = {"type":"div","props":{},"children":[{"type":"p","props":{},"children":["A couple shots out to the west. That's the new Comcast building in-progress to the south. Shot with the x100s."]},"\n",{"type":"p","props":{},"children":[{"type":"img","props":{"src":"/static/images/posts/2016-09-21-sunset/one.jpg","alt":"one"}},"\n",{"type":"img","props":{"src":"/static/images/posts/2016-09-21-sunset/two.jpg","alt":"two"}}]}]}
  return (
    <Post {...data}>
      <ComponentTree {...body} components={components} />
    </Post>
  )
}
